
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, useMediaQuery, MenuItem, Select, Typography, IconButton } from "@mui/material";
import DashboardCard from "../../../components/Cards/DashboardCard";
import PresentIcon from "../../../assets/StatusIcons/PresentIcon.svg";
import AbsentIcon from "../../../assets/StatusIcons/AbsentIcon.svg";
import HalfLeaveIcon from "../../../assets/StatusIcons/HalfLeaveIcon.svg";
import dashboardmap from "../../../assets/Dashboard/dashboardmap.png";
import mapicon from "../../../assets/Dashboard/mapicon.svg";
import CustomButton from "../../../components/CustomButton";
import maparrow from "../../../assets/maparrow.svg";
import { showUnderDevelopment } from "../../../components/Alert.js";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from '../../../components/BaseUrl.js';
import EarlyOutIcon from "../../../assets/StatusIcons/EarlyOutIcon.svg";
import LeaveIcon from "../../../assets/StatusIcons/LeaveIcon.svg";

import LateIcon from "../../../assets/StatusIcons/LateIcon.svg"
import CalendarTask from "../TaskManagement/CalenderView/CalenderView.js";
import DashboardRequests from "../Dashboard/DashboardRequest.js";
import DashboardTable from "../Dashboard/DashboardClients.js";

const ReportsandStatistics = () => {
  const { t, i18n, ready } = useTranslation();
  const isMobile = useMediaQuery("(max-width:768px)");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const handleRowClick = (row) => {
    setSelectedRowData(row);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRowData(null);
  };
  const handleViewDetails = () => {
    setIsModalOpen(false);
    setIsDetailModalOpen(true);
  };
  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedRowData(null);
  };

  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const getToday = () => new Date().toISOString().split("T")[0];

 const [liveAttendance, setLiveAttendance] = useState(null);
  const [liveLoading, setLiveLoading] = useState(true);
  const [liveError, setLiveError] = useState(null);

  useEffect(() => {
    const fetchLiveAttendance = async () => {
      if (!decryptedToken) return;
      setLiveLoading(true);
      setLiveError(null);
      try {
        const res = await fetch(`${BASE_URL}/company-admins/attendance/today`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        const json = await res.json();
        if (json?.error) {
          setLiveError(json?.message || "Failed to fetch live attendance");
        } else {
          setLiveAttendance(json?.data || null);
        }
      } catch (err) {
        console.error("Error fetching live attendance:", err);
        setLiveError("Network error while fetching live attendance");
      } finally {
        setLiveLoading(false);
      }
    };

    fetchLiveAttendance();
  }, [decryptedToken]);
   const counters = liveAttendance?.counters || {};
  const rows =
    liveAttendance?.table?.rows ||
    liveAttendance?.rows ||
    [];

  const safeNum = (val) => (typeof val === "number" ? val : "-");

  const totals = overview?.totals || {};
  if (!ready) return <div>Loading translations...</div>;

  return (
    <Box sx={{ pl: isMobile ? 0.5 : 1.5, pr: isMobile ? 0.5 : 0, py: 2 }}>
   <Box
  sx={{
    display: "grid",
    gap: 1,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(6, 1fr)", // show all six in a row on large screens
      xl: "repeat(6, 1fr)",
    },
  }}
>
  <DashboardCard
    icon={PresentIcon}
    title={t("dashboards.present")}
    description={liveLoading ? "…" : safeNum(counters.present)}
  />

  <DashboardCard
    icon={AbsentIcon}
    title={t("dashboards.absent")}
    description={liveLoading ? "…" : safeNum(counters.absent)}
  />

  <DashboardCard
    icon={LateIcon}
    title={t("dashboards.lateArrival")}       // en: Late Arrivals / es: Llegadas Tardías
    description={liveLoading ? "…" : safeNum(counters.lateArrivals)}
  />

  <DashboardCard
    icon={EarlyOutIcon}                        // <-- import your Early Out SVG
    title={t("dashboards.earlyOut")}           // en: Early Out / es: Salida Temprana
    description={liveLoading ? "…" : safeNum(counters.earlyOut)}
  />
  <DashboardCard
    icon={LeaveIcon}                           // <-- import your Leave SVG
    title={t("dashboards.leave")}              // en: Leave / es: Permiso
    description={liveLoading ? "…" : safeNum(counters.leave)}
  />
  <DashboardCard
    icon={HalfLeaveIcon}
    title={t("dashboards.halfLeave")}          // en: Half Leave / es: Medio Permiso
    description={liveLoading ? "…" : safeNum(counters.halfLeave)}
  />
</Box>
      <Box sx={{ position: "relative", mt: 1, display: "flex", alignItems: "flex-start", justifyContent: "flex-start", gap: 2, flexWrap: isMobile ? "wrap" : "nowrap", width: "100%" }}>
        <Box sx={{ width: "100%", overflowX: "auto"}}>
          <DashboardTable onRowClick={handleRowClick} />
        </Box>
      </Box>
      <Box sx={{mt:1}}>
        <CalendarTask/>
        </Box>
        <Box>
          <DashboardRequests/>
          </Box>
    </Box>
  );
};

export default ReportsandStatistics;